import { Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component'; // Import Lucide

let nextToggleId = 0;

@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [CommonModule, LucideIconComponent],
  templateUrl: './toggle.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
})
export class ToggleComponent implements ControlValueAccessor {
  readonly toggleId = `app-toggle-${++nextToggleId}`;
  label = input<string>();
  iconOn = input<string>();
  iconOff = input<string>();

  disabled = signal<boolean>(false);

  value = false;
  onChange: (value: boolean) => void = () => {};
  onTouched: () => void = () => {};

  toggleValue() {
    if (this.disabled()) return;
    this.value = !this.value;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(value: boolean): void {
    this.value = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
